import { FILES } from 'conversations-message-history/common-message-format/constants/attachmentTypes';
export const removeFileAttachmentFromCommonMessage = commonMessage => {
  const cmfWithoutFileAttachments = commonMessage.updateIn(['attachments'], attachments => {
    return attachments.filter(attachment => {
      return attachment['@type'] !== FILES;
    });
  });
  return cmfWithoutFileAttachments;
};